<script>
import Loader from "../components/Loader.vue";
import AOS from "aos";
import { onMounted } from "vue";
export default {
  name: "Work",
  data() {
    return {
      projects: [],
      loading: false,
    };
  },
  components: { Loader },
  mounted() {
    this.loading = true;
    fetch("https://port-backend-bice.vercel.app/projects")
      .then((res) => res.json())
      .then((data) => {
        this.projects = data;
        this.loading = false;
      })
      .catch((err) => console.log(err.message));
  },
  setup() {
    onMounted(() => {
      AOS.init();
    });
  },
};
</script>

<template>
  <div
    id="work-page"
    class="h-full pt-24 md:pt-16 md:h-screen dark:bg-black lg:px-0 md:px-4"
  >
    <div class="mx-auto maxWidth snap-x" data-aos="fade-up">
      <div class="flex flex-col items-center md:items-start">
        <h1 class="text-6xl font-bold textBlue">Work</h1>
        <p class="text-lg font-normal text-left dark:text-gray-300">
          My latest projects
        </p>
      </div>
      <div
        class="hidden pt-10 overflow-auto md:block md:pt-10 snap-center scrollbar-hidden"
      >
        <div class="containerGrid">
          <div v-for="project in projects" :key="project.id" class="">
            <div class="flex items-center justify-center">
              <div class="relative flex group">
                <div class="relative cardMobile1">
                  <img
                    class="absolute opacity-60 cardMobile1"
                    :src="project.img"
                    :alt="project.title"
                  />
                  <div
                    class="flex flex-col transition-all duration-500 ease-in-out transform translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0"
                  >
                    <div class="flex flex-col items-start ml-8">
                      <h1 class="text-2xl font-bold text-white uppercase">
                        {{ project.title }}
                      </h1>
                      <h1 class="text-lg font-semibold text-white">
                        {{ project.lang }}
                      </h1>
                      <h1 class="text-sm font-normal text-white">
                        {{ project.desc }}
                      </h1>
                    </div>
                    <div class="flex justify-end gap-4 mt-10 mr-8">
                      <a :href="project.github" target="_blank"
                        ><svg
                          width="20"
                          height="20"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.10059 19.0137C8.10059 19.1113 7.98828 19.1895 7.84668 19.1895C7.68555 19.2041 7.57324 19.126 7.57324 19.0137C7.57324 18.916 7.68555 18.8379 7.82715 18.8379C7.97363 18.8232 8.10059 18.9014 8.10059 19.0137ZM6.58203 18.7939C6.54785 18.8916 6.64551 19.0039 6.79199 19.0332C6.91895 19.082 7.06543 19.0332 7.09473 18.9355C7.12402 18.8379 7.03125 18.7256 6.88477 18.6816C6.75781 18.6475 6.61621 18.6963 6.58203 18.7939ZM8.74023 18.7109C8.59863 18.7451 8.50098 18.8379 8.51562 18.9502C8.53027 19.0479 8.65723 19.1113 8.80371 19.0771C8.94531 19.043 9.04297 18.9502 9.02832 18.8525C9.01367 18.7598 8.88184 18.6963 8.74023 18.7109ZM11.9531 0C5.18066 0 0 5.1416 0 11.9141C0 17.3291 3.4082 21.9629 8.27637 23.5938C8.90137 23.7061 9.12109 23.3203 9.12109 23.0029C9.12109 22.7002 9.10645 21.0303 9.10645 20.0049C9.10645 20.0049 5.68848 20.7373 4.9707 18.5498C4.9707 18.5498 4.41406 17.1289 3.61328 16.7627C3.61328 16.7627 2.49512 15.9961 3.69141 16.0107C3.69141 16.0107 4.90723 16.1084 5.57617 17.2705C6.64551 19.1553 8.4375 18.6133 9.13574 18.291C9.24805 17.5098 9.56543 16.9678 9.91699 16.6455C7.1875 16.3428 4.43359 15.9473 4.43359 11.25C4.43359 9.90723 4.80469 9.2334 5.58594 8.37402C5.45898 8.05664 5.04395 6.74805 5.71289 5.05859C6.7334 4.74121 9.08203 6.37695 9.08203 6.37695C10.0586 6.10352 11.1084 5.96191 12.1484 5.96191C13.1885 5.96191 14.2383 6.10352 15.2148 6.37695C15.2148 6.37695 17.5635 4.73633 18.584 5.05859C19.2529 6.75293 18.8379 8.05664 18.7109 8.37402C19.4922 9.23828 19.9707 9.91211 19.9707 11.25C19.9707 15.9619 17.0947 16.3379 14.3652 16.6455C14.8145 17.0312 15.1953 17.7637 15.1953 18.9111C15.1953 20.5566 15.1807 22.5928 15.1807 22.9932C15.1807 23.3105 15.4053 23.6963 16.0254 23.584C20.9082 21.9629 24.2188 17.3291 24.2188 11.9141C24.2188 5.1416 18.7256 0 11.9531 0ZM4.74609 16.8408C4.68262 16.8896 4.69727 17.002 4.78027 17.0947C4.8584 17.1729 4.9707 17.207 5.03418 17.1436C5.09766 17.0947 5.08301 16.9824 5 16.8896C4.92188 16.8115 4.80957 16.7773 4.74609 16.8408ZM4.21875 16.4453C4.18457 16.5088 4.2334 16.5869 4.33105 16.6357C4.40918 16.6846 4.50684 16.6699 4.54102 16.6016C4.5752 16.5381 4.52637 16.46 4.42871 16.4111C4.33105 16.3818 4.25293 16.3965 4.21875 16.4453ZM5.80078 18.1836C5.72266 18.2471 5.75195 18.3936 5.86426 18.4863C5.97656 18.5986 6.11816 18.6133 6.18164 18.5352C6.24512 18.4717 6.21582 18.3252 6.11816 18.2324C6.01074 18.1201 5.86426 18.1055 5.80078 18.1836ZM5.24414 17.4658C5.16602 17.5146 5.16602 17.6416 5.24414 17.7539C5.32227 17.8662 5.4541 17.915 5.51758 17.8662C5.5957 17.8027 5.5957 17.6758 5.51758 17.5635C5.44922 17.4512 5.32227 17.4023 5.24414 17.4658Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      <a :href="project.link" target="_blank"
                        ><svg
                          width="20"
                          height="20"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.0938 15.625H19.5312C19.324 15.625 19.1253 15.7073 18.9788 15.8538C18.8323 16.0003 18.75 16.199 18.75 16.4062V21.875H3.125V6.25H10.1562C10.3635 6.25 10.5622 6.16769 10.7087 6.02118C10.8552 5.87466 10.9375 5.67595 10.9375 5.46875V3.90625C10.9375 3.69905 10.8552 3.50034 10.7087 3.35382C10.5622 3.20731 10.3635 3.125 10.1562 3.125H2.34375C1.72215 3.125 1.12601 3.37193 0.686468 3.81147C0.24693 4.25101 0 4.84715 0 5.46875L0 22.6562C0 23.2779 0.24693 23.874 0.686468 24.3135C1.12601 24.7531 1.72215 25 2.34375 25H19.5312C20.1529 25 20.749 24.7531 21.1885 24.3135C21.6281 23.874 21.875 23.2779 21.875 22.6562V16.4062C21.875 16.199 21.7927 16.0003 21.6462 15.8538C21.4997 15.7073 21.301 15.625 21.0938 15.625ZM23.8281 0H17.5781C16.5347 0 16.0132 1.26514 16.748 2.00195L18.4927 3.74658L6.5918 15.6431C6.48255 15.7519 6.39586 15.8813 6.33672 16.0237C6.27757 16.1662 6.24712 16.3189 6.24712 16.4731C6.24712 16.6274 6.27757 16.7801 6.33672 16.9225C6.39586 17.065 6.48255 17.1944 6.5918 17.3032L7.69873 18.4082C7.8076 18.5175 7.93697 18.6041 8.07941 18.6633C8.22185 18.7224 8.37457 18.7529 8.52881 18.7529C8.68304 18.7529 8.83576 18.7224 8.9782 18.6633C9.12065 18.6041 9.25002 18.5175 9.35889 18.4082L21.2539 6.50977L22.998 8.25195C23.7305 8.98438 25 8.47168 25 7.42188V1.17188C25 0.861074 24.8765 0.563003 24.6568 0.343234C24.437 0.123465 24.1389 0 23.8281 0Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex pt-10 overflow-auto md:hidden md:pt-28 snap-center scrollbar-hidden"
      >
        <div class="flex gap-4 px-5 scrollbar-hidden md:px-0">
          <div v-for="project in projects" :key="project.id" class="">
            <div class="flex items-center justify-center gap-3">
              <div class="relative flex group">
                <div class="relative cardMobile">
                  <img
                    class="absolute opacity-60 cardMobile"
                    :src="project.img"
                    :alt="project.title"
                  />
                  <div
                    class="flex flex-col transition-all duration-500 ease-in-out transform translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0"
                  >
                    <div class="flex flex-col items-start ml-8">
                      <h1 class="text-2xl font-bold text-white uppercase">
                        {{ project.title }}
                      </h1>
                      <h1 class="text-lg font-semibold text-white">
                        {{ project.lang }}
                      </h1>
                      <h1 class="text-base font-normal text-white">
                        {{ project.desc }}
                      </h1>
                    </div>
                    <div class="flex justify-end gap-4 mt-32 mr-8">
                      <a :href="project.github" target="_blank"
                        ><svg
                          width="20"
                          height="20"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.10059 19.0137C8.10059 19.1113 7.98828 19.1895 7.84668 19.1895C7.68555 19.2041 7.57324 19.126 7.57324 19.0137C7.57324 18.916 7.68555 18.8379 7.82715 18.8379C7.97363 18.8232 8.10059 18.9014 8.10059 19.0137ZM6.58203 18.7939C6.54785 18.8916 6.64551 19.0039 6.79199 19.0332C6.91895 19.082 7.06543 19.0332 7.09473 18.9355C7.12402 18.8379 7.03125 18.7256 6.88477 18.6816C6.75781 18.6475 6.61621 18.6963 6.58203 18.7939ZM8.74023 18.7109C8.59863 18.7451 8.50098 18.8379 8.51562 18.9502C8.53027 19.0479 8.65723 19.1113 8.80371 19.0771C8.94531 19.043 9.04297 18.9502 9.02832 18.8525C9.01367 18.7598 8.88184 18.6963 8.74023 18.7109ZM11.9531 0C5.18066 0 0 5.1416 0 11.9141C0 17.3291 3.4082 21.9629 8.27637 23.5938C8.90137 23.7061 9.12109 23.3203 9.12109 23.0029C9.12109 22.7002 9.10645 21.0303 9.10645 20.0049C9.10645 20.0049 5.68848 20.7373 4.9707 18.5498C4.9707 18.5498 4.41406 17.1289 3.61328 16.7627C3.61328 16.7627 2.49512 15.9961 3.69141 16.0107C3.69141 16.0107 4.90723 16.1084 5.57617 17.2705C6.64551 19.1553 8.4375 18.6133 9.13574 18.291C9.24805 17.5098 9.56543 16.9678 9.91699 16.6455C7.1875 16.3428 4.43359 15.9473 4.43359 11.25C4.43359 9.90723 4.80469 9.2334 5.58594 8.37402C5.45898 8.05664 5.04395 6.74805 5.71289 5.05859C6.7334 4.74121 9.08203 6.37695 9.08203 6.37695C10.0586 6.10352 11.1084 5.96191 12.1484 5.96191C13.1885 5.96191 14.2383 6.10352 15.2148 6.37695C15.2148 6.37695 17.5635 4.73633 18.584 5.05859C19.2529 6.75293 18.8379 8.05664 18.7109 8.37402C19.4922 9.23828 19.9707 9.91211 19.9707 11.25C19.9707 15.9619 17.0947 16.3379 14.3652 16.6455C14.8145 17.0312 15.1953 17.7637 15.1953 18.9111C15.1953 20.5566 15.1807 22.5928 15.1807 22.9932C15.1807 23.3105 15.4053 23.6963 16.0254 23.584C20.9082 21.9629 24.2188 17.3291 24.2188 11.9141C24.2188 5.1416 18.7256 0 11.9531 0ZM4.74609 16.8408C4.68262 16.8896 4.69727 17.002 4.78027 17.0947C4.8584 17.1729 4.9707 17.207 5.03418 17.1436C5.09766 17.0947 5.08301 16.9824 5 16.8896C4.92188 16.8115 4.80957 16.7773 4.74609 16.8408ZM4.21875 16.4453C4.18457 16.5088 4.2334 16.5869 4.33105 16.6357C4.40918 16.6846 4.50684 16.6699 4.54102 16.6016C4.5752 16.5381 4.52637 16.46 4.42871 16.4111C4.33105 16.3818 4.25293 16.3965 4.21875 16.4453ZM5.80078 18.1836C5.72266 18.2471 5.75195 18.3936 5.86426 18.4863C5.97656 18.5986 6.11816 18.6133 6.18164 18.5352C6.24512 18.4717 6.21582 18.3252 6.11816 18.2324C6.01074 18.1201 5.86426 18.1055 5.80078 18.1836ZM5.24414 17.4658C5.16602 17.5146 5.16602 17.6416 5.24414 17.7539C5.32227 17.8662 5.4541 17.915 5.51758 17.8662C5.5957 17.8027 5.5957 17.6758 5.51758 17.5635C5.44922 17.4512 5.32227 17.4023 5.24414 17.4658Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      <a :href="project.link" target="_blank"
                        ><svg
                          width="20"
                          height="20"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.0938 15.625H19.5312C19.324 15.625 19.1253 15.7073 18.9788 15.8538C18.8323 16.0003 18.75 16.199 18.75 16.4062V21.875H3.125V6.25H10.1562C10.3635 6.25 10.5622 6.16769 10.7087 6.02118C10.8552 5.87466 10.9375 5.67595 10.9375 5.46875V3.90625C10.9375 3.69905 10.8552 3.50034 10.7087 3.35382C10.5622 3.20731 10.3635 3.125 10.1562 3.125H2.34375C1.72215 3.125 1.12601 3.37193 0.686468 3.81147C0.24693 4.25101 0 4.84715 0 5.46875L0 22.6562C0 23.2779 0.24693 23.874 0.686468 24.3135C1.12601 24.7531 1.72215 25 2.34375 25H19.5312C20.1529 25 20.749 24.7531 21.1885 24.3135C21.6281 23.874 21.875 23.2779 21.875 22.6562V16.4062C21.875 16.199 21.7927 16.0003 21.6462 15.8538C21.4997 15.7073 21.301 15.625 21.0938 15.625ZM23.8281 0H17.5781C16.5347 0 16.0132 1.26514 16.748 2.00195L18.4927 3.74658L6.5918 15.6431C6.48255 15.7519 6.39586 15.8813 6.33672 16.0237C6.27757 16.1662 6.24712 16.3189 6.24712 16.4731C6.24712 16.6274 6.27757 16.7801 6.33672 16.9225C6.39586 17.065 6.48255 17.1944 6.5918 17.3032L7.69873 18.4082C7.8076 18.5175 7.93697 18.6041 8.07941 18.6633C8.22185 18.7224 8.37457 18.7529 8.52881 18.7529C8.68304 18.7529 8.83576 18.7224 8.9782 18.6633C9.12065 18.6041 9.25002 18.5175 9.35889 18.4082L21.2539 6.50977L22.998 8.25195C23.7305 8.98438 25 8.47168 25 7.42188V1.17188C25 0.861074 24.8765 0.563003 24.6568 0.343234C24.437 0.123465 24.1389 0 23.8281 0Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  background: #000;
  width: 450px;
  height: 300px;
  object-fit: cover;
}

.cardMobile {
  background: #000;
  width: 450px;
  height: 300px;
  object-fit: cover;
}
.cardMobile1 {
  background: #000;
  width: 400px;
  height: 250px;
  object-fit: cover;
}

.card1 {
  background: #000;
  width: 450px;
  height: 300px;
  object-fit: cover;
}

.containerGrid {
  display: grid;
  grid-template-columns: auto auto auto;
  padding: 10px;
  gap: 10px;
}

@media only screen and (max-width: 1218px) {
  .containerGrid {
    display: grid;
    grid-template-columns: auto auto;
    /* padding: 5px;
    gap: 5px; */
  }
}
</style>
